
import React from "react";
import { Badge } from "@/components/ui/badge";
import { FolderIcon } from "lucide-react";
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface GroupBadgeProps {
  groupName: string;
  groupDescription?: string;
}

export function GroupBadge({ groupName, groupDescription }: GroupBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className="flex items-center gap-1">
            <FolderIcon className="h-3 w-3" />
            <span>{groupName}</span>
          </Badge>
        </TooltipTrigger>
        {groupDescription && (
          <TooltipContent>
            <p>{groupDescription}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
